import { render } from "./TableMessagesGenerals.vue?vue&type=template&id=29afde3e&scoped=true"
import script from "./TableMessagesGenerals.vue?vue&type=script&lang=js"
export * from "./TableMessagesGenerals.vue?vue&type=script&lang=js"

import "./TableMessagesGenerals.vue?vue&type=style&index=0&id=29afde3e&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29afde3e"]])

export default __exports__